<template>
  <div
    class="toggle"
    :class="[{ 'is-open': isActive }, { 'is-inline': inline }]"
  >
    <div
      class="flex flex-1 cursor-pointer"
      :class="triggerClassHeader"
      @click="toggleItem"
    >
      <slot name="header">
        <span class="toggle-name me-auto" :class="triggerClassTitle">
          {{ name }}
        </span>
      </slot>
      <slot name="action" />
      <new-feature-badge v-if="showNewBadge" class="me-2 mb-1" />

      <div class="toggle-btn-wrapper flex" :class="triggerClassBtn">
        <span v-if="isActive">
          <slot name="btn-hide">
            <!-- if it is active we have the is-open class to trigger the animation and rotate it... -->
            <svg-icon
              class="icon-sm is-open"
              :class="iconColor"
              name="chevron-down"
            />
          </slot>
        </span>
        <span v-else>
          <slot name="btn-show">
            <svg-icon class="icon-sm" :class="iconColor" name="chevron-down" />
          </slot>
        </span>
      </div>
    </div>

    <div>
      <div
        v-if="keepContentLoaded || isActive"
        v-show="isActive"
        :class="triggerClassContent"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { trackEvent } from "@/plugins/vueApplicationInsights";
import NewFeatureBadge from "@/components/ui/NewFeatureBadge.vue";

export default {
  components: {
    NewFeatureBadge,
  },
  props: {
    name: {
      type: String,
      default: "",
    },
    showNewBadge: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    isOpenByDefault: {
      type: Boolean,
      default: false,
    },
    keepContentLoaded: {
      type: Boolean,
      default: false,
    },
    iconColor: {
      type: String,
      default: "text-blue-500",
    },
    triggerClassHeader: {
      type: String,
      default: "",
    },
    triggerClassTitle: {
      type: String,
      default: "",
    },
    triggerClassContent: {
      type: String,
      default: "",
    },
    triggerClassBtn: {
      type: String,
      default: "",
    },
    trackEventName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
  mounted() {
    this.updateOpenState();
  },
  methods: {
    updateOpenState() {
      this.isActive = this.isOpenByDefault;
    },
    toggleItem() {
      this.isActive = !this.isActive;
      if (this.isActive && this.trackEventName) {
        trackEvent(this.trackEventName);
      }
    },
  },
  watch: {
    isOpenByDefault() {
      this.updateOpenState();
    },
  },
};
</script>

<style lang="postcss" scoped>
.toggle-border::after {
  @apply w-full border-t border-gray-300;
  content: "";
}

.fade-enter {
  opacity: 0;
  transform: translateY(-4px);
}

.fade-enter-active {
  transition: opacity var(--t-duration) var(--t-easing),
    transform var(--t-duration-long) var(--t-easing);
}

.is-inline {
  & .toggle-name {
    @apply truncate me-4;
    flex: 0 0 auto;
  }

  & .toggle-btn-wrapper {
    @apply justify-start flex-1;
  }
}

.toggle-btn-wrapper {
  & .svg-icon {
    transition-property: transform;
    transition-duration: var(--t-duration);
    transition-timing-function: var(--t-easing);
  }

  & .is-open {
    &.svg-icon--chevron-down {
      transform: rotate(180deg);
    }
  }
}
</style>
